import { render, staticRenderFns } from "./requestGoodsResponse.pug?vue&type=template&id=2e1d4813&scoped=true&lang=pug&"
import script from "./requestGoodsResponse.ts?vue&type=script&lang=ts&"
export * from "./requestGoodsResponse.ts?vue&type=script&lang=ts&"
import style0 from "./requestGoodsResponse.scss?vue&type=style&index=0&id=2e1d4813&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1d4813",
  null
  
)

export default component.exports